module.exports = __webpack_public_path__ + "img/shield-bios-banner-03-square.9d8435e6.jpg";